import { Button } from "../button";
import { ISubmitButton } from "./submit-button.types";

export const SubmitButton: ISubmitButton = ({ loading }) => (
  <Button
    type="submit"
    loading={loading}
    className="w-full md:w-[168px] h-[50px] md:h-[60px]  mt-[40px]"
  >
    send
  </Button>
);
